import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type LiveVideoRequest = {
  clientId?: string | null;
  data: string;
};

export type LiveVideo = {
  id: string;
  clientId: string;
  language: string;
  challenges: object[];
  createdAt: string;
  updateAt: string;
};

export class LiveVideos extends Resource<LiveVideoRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("liveVideos", axiosInstance);
  }

  public async get(id: string): Promise<LiveVideo> {
    return this.request({ method: Method.GET, path: id });
  }

  public async redact(id: string): Promise<void> {
    return this.request({ method: Method.POST, path: `${id}/redact` });
  }

  public async delete(id: string): Promise<void> {
    await this.request({ method: Method.DELETE, path: id });
  }

  public async list(
    clientId: string,
    {
      page,
      pageSize
    }: {
      page?: number;
      pageSize?: number;
    } = {}
  ): Promise<LiveVideo[]> {
    const { items: liveVideos } = await this.request({
      method: Method.GET,
      query: { clientId, page, pageSize }
    });

    return liveVideos;
  }
}
